import { render, staticRenderFns } from "./edit_settings.vue?vue&type=template&id=8f01b088"
import script from "./edit_settings.vue?vue&type=script&lang=js"
export * from "./edit_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports